// extracted by mini-css-extract-plugin
module.exports = {"menu_item":"style_menu_item__2hZ7M"};